import React from 'react'
import { useTranslation } from 'react-i18next'
import KPICard from './KPICard'
import { calculateAllMetrics } from '../utils/financialCalculations'

const CalculatedMetricsPreview = ({ metrics, previousMetrics }) => {
  const { t } = useTranslation('dashboard')
  const previousCalculatedMetrics = previousMetrics
    ? calculateAllMetrics(previousMetrics)
    : null
  const comparisonLabel = t('kpi.comparison.previousPeriod')

  const cards = [
    {
      metricType: 'netProfit',
      title: t('kpi.netProfit.title'),
      value: metrics.netProfit,
      previousValue: previousCalculatedMetrics?.netProfit,
      isCurrency: true,
    },
    {
      metricType: 'profitMargin',
      title: t('kpi.profitMargin.title'),
      value: metrics.profitMargin,
      previousValue: previousCalculatedMetrics?.profitMargin,
      isPercentage: true,
    },
    {
      metricType: 'conversionRate',
      title: t('kpi.conversionRate.title'),
      value: metrics.conversionRate,
      previousValue: previousCalculatedMetrics?.conversionRate,
      isPercentage: true,
    },
    {
      metricType: 'revenueGrowth',
      title: t('kpi.revenueGrowth.title'),
      value: metrics.revenueGrowth,
      // Revenue growth already compares the current period with the previous one.
      previousValue: null,
      isPercentage: true,
    },
    {
      metricType: 'expenseRatio',
      title: t('kpi.expenseRatio.title'),
      value: metrics.expenseRatio,
      previousValue: previousCalculatedMetrics?.expenseRatio,
      isPercentage: true,
    },
  ]

  return (
    <div className="grid grid-cols-1 items-stretch gap-[14px] sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
      {cards.map((card) => (
        <KPICard
          key={card.metricType}
          {...card}
          comparisonLabel={comparisonLabel}
        />
      ))}
    </div>
  )
}

export default CalculatedMetricsPreview
